import {NotApplicable} from 'rlink-collections/symbols';
import inspectableError from 'rlink-inspectable-error';
/**
 * Returns a set of usable collections functions for the
 * implementation functions. Implementation functions can
 * access each-other using `this` and must return NotApplicable
 * for arguments they do not support (when another
 * implementation might). You can call addImplementations to add
 * more implementations to the same collections object, or
 * withImplementations to return a new collections object with
 * additional implementations added.
 *
 * @param  {Object} ...implementations
 * @return {Object}
 */
export default function collections (...implementationSets) {
  let collectionsObj = {
    implementations: {},
    unboundImplementations: [],
    NotApplicable,
    addImplementations (implementations) {
      for (let [name, fn] of Object.entries(implementations)) {
        if (!(name in collectionsObj.implementations)) {
          collectionsObj.implementations[name] = [];
        }
        collectionsObj.implementations[name].push(fn.bind(collectionsObj));
        if (!(name in collectionsObj)) {
          collectionsObj[name] = (...args) => collectionsObj.callImplementationFunction(name, args, false);
        }
      }
      collectionsObj.unboundImplementations.push(implementations);
    },

    withImplementations (...implementations) {
      return collections(...collectionsObj.unboundImplementations, ...implementations);
    },

    isIterable (...args) {
      return collectionsObj.callImplementationFunction('isIterable', args, true);
    },

    isCollection (...args) {
      return collectionsObj.callImplementationFunction('isCollection', args, true);
    },

    callImplementationFunction (name, args, isPredicate = false) {
      if (!(name in collectionsObj.implementations)) {
        throw new TypeError(`${name}() is not a collections function.`);
      }
      let implementations = collectionsObj.implementations[name];
      if (implementations.length === 0 ) {
        throw new TypeError(`No implementations provided for ${name}()`);
      }
      for (let implementation of implementations) {
        let result = implementation(...args);
        if (isPredicate) {
          if (result === true) {
            return true;
          }
        } else {
          if (result !== NotApplicable) {
            return result;
          }
        }
      }
      if (isPredicate) {
        return false;
      } else {
        throw inspectableError`No implementation was able to handle ${name}(${{args}})`;
      }

    },
  };
  for (let implementations of implementationSets) {
    collectionsObj.addImplementations(implementations);
  }
  return collectionsObj;
}



// WEBPACK FOOTER //
// ./lib/rlink-collections/collections.js